<ng-container *ngIf="!item.hidden && hasVisibleChildren">
    <li class="nav-item pcoded-menu-caption" *ngIf="item.title">
      <label>{{ item.title | translate }}</label>
    </li>
    <ng-container *ngFor="let item of item.children">
      <app-nav-group *ngIf="item.type === 'group'" [item]="item" [allowedPermissions]="allowedPermissions" [isPhoneViewport]="isPhoneViewport"></app-nav-group>
      <app-nav-collapse *ngIf="item.type === 'collapse'" [item]="item"></app-nav-collapse>
      <app-nav-item *ngIf="item.type === 'item'" [item]="item" [allowedPermissions]="allowedPermissions" [isPhoneViewport]="isPhoneViewport"></app-nav-item>
    </ng-container>
  </ng-container>
  